import React from "react";
import { humanReadableDate } from "../../../../app/utils";
import { LineSeperator } from "../../../../components/RegularComponents";

export const CriminalHistoryTab = (props) => {
    const { appData } = props;
    const { criminalHistoryData } = appData

    if(criminalHistoryData && Array.isArray(criminalHistoryData)) { 
        return (
            <div style={{marginTop: "1em"}}>
                {criminalHistoryData.map((criminalHistoryItem, index) => (
                    <div key={index}>
                        <DetailSection criminalHistoryItem={criminalHistoryItem} />
                        <LineSeperator />
                    </div>
                ))}
            </div>
        )    
    }

    return null
}

const DetailSection = ({ criminalHistoryItem }) => {
    return (
        <>
        {/* Name */}
        <div className="row">
            <div className="collector-licence-col col-md-4" style={{ flexGrow: 1, display: "flex", fontWeight: "bold" }}>
                <span>Name</span>
            </div>

            <div className="collector-licence-col col-md-6" style={{ display: "flex" }}>
                {criminalHistoryItem.person}
            </div>
        </div>
        {/* Date of offence */}
        <div className="row section-row-margin">
            <div className="collector-licence-col col-md-4" style={{ flexGrow: 1, display: "flex", fontWeight: "bold" }}>
                <span>Date of offence</span>
            </div>

            <div className="collector-licence-col col-md-6" style={{ display: "flex" }}>
                {humanReadableDate(criminalHistoryItem.dateOfOffence)}
            </div>
        </div>
        {/*description */}
        <div className="row">
            <div className="collector-licence-col col-md-4" style={{ flexGrow: 1, display: "flex", fontWeight: "bold" }}>
                <span>Description</span>
            </div>

            <div className="collector-licence-col col-md-6" style={{ display: "flex" }}>
                {criminalHistoryItem.description}
            </div>
        </div>
        </>
    )
}